module.exports = __webpack_public_path__ + "static/media/sun.ceb9ac26.png";